<script src="../../../router/PropertyFee.js"></script>
<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <!-- <button-add @click="toAddPage1" value="配置用电配额"></button-add>
        <button-add @click="toAddPage2" value="生成账单"></button-add> -->
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('040001008') !== -1"></button-add>
          <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage"
          v-if="permissionCodes.indexOf('040001005') !== -1"
          value="导入"/>
          <button-export
          :href="exportMbUrl"
          download="download.xls"
          :beforeDownload="beforeDownloadMB"
          value="导入模板下载"/>
          <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" v-if="permissionCodes.indexOf('013002007') !== -1" style="margin-left: 10px;"/>
      </div>
    <div style="display: flex;justify-content: space-between">
      <input-search  placeholder="住户名称/房间号"  @search="searchKey"/>
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        style="margin: 0 0 0 8px"
        download="download.xls"
        v-if="permissionCodes.indexOf('040001004') !== -1"
        value="导出"/>
    </div>
  </div>
      <div class="search-line">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">物业费缴纳日期</span>
          <el-date-picker v-model="timevalue"  size="small" type="datetimerange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div>
          <input-select selectTitle="补交物业费状态" :selectKey="'status'" :selectData="categoryTypeList" style="margin:0 20px" @search="search"/>
        </div>
      </div>


  <el-table
    ref="multipleTable"
    :data="tableData"
    :header-cell-style="{'text-align':'center'}"
    :cell-style="{'text-align':'center'}"
    style="width: 100%"
    @selection-change="handleSelectionChange">
      <el-table-column
      type="selection"
      width="55">
      </el-table-column>
      <el-table-column
        prop="enterpriseName"
        label="住户名称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="roomInfoName"
        label="房间号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="contractCode"
        label="合同编号"
        width="180">
      </el-table-column>
    <el-table-column label="物业费">
      <el-table-column
        prop="duration"
        label="物业费区间"
        width="160">
      </el-table-column>
        <el-table-column
          prop="proprtyArea"
          label="物业费缴费面积"
          width="120">
        </el-table-column>
        <el-table-column
          prop="monCount"
          label="月数"
          width="120">
        </el-table-column>
        <el-table-column
          prop="price"
          label="物业费单价"
          width="120">
        </el-table-column>
        <el-table-column
          prop="payMoney"
          label="物业费"
          width="120">
        </el-table-column>
        <el-table-column
          prop="payTime"
          label="物业费缴纳日期"
          width="120">
        </el-table-column>
    </el-table-column>
    <el-table-column label="补交物业费">
        <el-table-column
          prop="ledgerDuration"
          label="补交物业费区间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="electricityDuration"
          label="电量计费周期"
          width="160">
        </el-table-column>
        <el-table-column
          prop="yearElectricityQuota"
          label="用电额度"
          width="120">
        </el-table-column>
        <el-table-column
          prop="yearElectricity"
          label="总用电量"
          width="120">
        </el-table-column>
        <el-table-column
          prop="overPrice"
          label="补交物业费单价"
          width="120">
        </el-table-column>
        <el-table-column
          prop="overMoney"
          label="补交物业费"
          width="120">
        </el-table-column>
        <el-table-column
          prop="overPayTime"
          label="补交物业费缴纳日期"
          width="120">
        </el-table-column>
    </el-table-column>
      <el-table-column
        prop="totalMoney"
        label="物业费合计"
        width="120">
      </el-table-column>
      <el-table-column
        prop="statusText"
        label="状态"
        width="120">
      </el-table-column>
      <el-table-column
      label="操作"
      fixed="right"
      width="240">
      <template slot-scope="scope">
        <div v-if="scope.row.status==='1'">
        <el-button @click="handleClick1(scope.row)" type="text" size="small">确认</el-button>
        <el-button @click="handleClick2(scope.row)" type="text" size="small">取消</el-button>
        </div>
        <div v-else-if="scope.row.status==='0'">未生成</div>
        <div v-else-if="scope.row.status==='2'">已确认</div>
        <el-button @click="notificationClick(scope.row)" type="text" size="small">通知单</el-button>
      </template>
    </el-table-column>
  </el-table>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="margin-top:15px"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="pageNum"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog title="通知单模板选择" :visible.sync="noticeDialogFormVisible" width="500px" class="contractDialogForm"
               v-loading="downloadNoticeLoading"
               element-loading-text="通知单生成中，请耐心等待"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in noticeTemplateList" class="contractDialogLine" :key="item.templateName">
          <div>{{item.templateName}}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract(item.path, item.fileName, item.code)">预览</span>
            <span @click="downloadContract(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div v-if="noticeTemplateList.length === 0" style="text-align: center;line-height: 30px;">暂无通知单模板</div>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/PropertyFee";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonAdd,
    ButtonCancel,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "property-fee-management",
  data() {
    return {
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "物业费台账"
        }
      ],
      fixTypeList: [],
      pageNum: 1,
      pageSize: 10,
      categoryTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "未生成"
        },
        {
          key: "1",
          label: "已生成"
        },
        {
          key: "2",
          label: "已确认"
        }
      ],
      tableData: [],
      requestData: {
        pageSize: 10,
        pageNum: 1,
        status: "",
        searchKey: ""
      },
      uploadUrl: "",
      exportUrl: "",
      exportMbUrl: "",
      timevalue: [],
      total: 0,
      multipleSelection: [],
      statusArr: [],
      multipleText: [],
      permissionCodes: "",
      noticeTemplateList: [],
      currentDueOverData: {},
      downloadNoticeLoading: false,
      noticeDialogFormVisible: false
    };
  },
  created() {
    this.getCreateTime();
    // this.getPage();
    // this.getCategoryList();
    this.uploadUrl = api.importFinancePropertyLedger;
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownloadMB() {
      this.exportMbUrl = `${api.exportNiceMould}`;
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-01" + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    beforeDownload() {
      this.exportUrl = `${api.exportPropertyFee}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&status=${this.requestData.status}`;
    },
    getNicePropertyFeePage(searchKey) {
      this.$axios
        .post(api.getCategoryList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.categoryName;
            });
            this.categoryTypeList = list;
            this.categoryTypeList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }

      this.$axios
        .post(api.getNicePropertyFeePage, this.requestData)
        .then(res => {
          let list = res.data.data.list;
          list.map(v => {
            if (v.status === "0") {
              v.statusText = "未生成";
            } else if (v.status === "1") {
              v.statusText = "已生成";
            } else if (v.status === "2") {
              v.statusText = "已确认";
            }
          });
          this.total = res.data.data.total;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "property-fee-management-add"
      });
    },

    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteStoreByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/warehousing_management_modify/${code}`
      });
    },
    handleSizeChange(val) {
      this.requestData.pageSize = val;
      this.getPage();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getPage();
    },
    handleSelectionChange(val) {
      this.multipleText = val;
    },
    handleClick1(row) {
      this.$axios
        .post(api.confirmPropertyFeeBill, { code: row.code })
        .then(res => {
          nSuccess("确认成功");
          this.getPage();
        })
        .catch(errorHandler("确认操作失败"));
    },
    handleClick2(row) {
      this.$axios
        .post(api.cancelPropertyFeeBill, { code: row.code })
        .then(res => {
          nSuccess("取消成功");
          this.getPage();
        })
        .catch(errorHandler("取消操作失败"));
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    notificationClick(data) {
      console.log(data);
      this.currentDueOverData = data;
      this.noticeDialogFormVisible = true;
      this.getTemplateList();
    },

    // 批量生成通知单
    batchDownloadNotice() {
      if (this.multipleText.length === 0) {
        nError("请先选择对应账单");
        return false;
      }
      this.noticeDialogFormVisible = true;
      this.getTemplateList();
    },

    // 获取催款单列表
    getTemplateList() {
      this.$axios
        .post(api.getTemplateList, {
          templateType: "2"
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.noticeTemplateList = data;
          }
        })
        .catch(errorHandler("获取催款单失败"));
    },

    // 催款单预览
    previewContract(path, fileName, code) {
      this.downloadNoticeLoading = true;
      let requestData = {};

      this.multipleText.map(v => {
        if (this.multipleSelection.indexOf(v.code) == -1)
          this.multipleSelection.push(v.code);
      });

      if (this.currentDueOverData.code) {
        requestData = {
          code: this.currentDueOverData.code,
          templateCode: code,
          fileName: fileName,
          templateUrl: path
        };
        this.$axios
          .post(api.createPropertyLedgerUrl, requestData)
          .then(res => {
            this.downloadNoticeLoading = false;
            if (res.data.retCode === 1) {
              let data = res.data.data;
              if (data) {
                window.open(
                  "http://view.officeapps.live.com/op/view.aspx?src=" + data,
                  "_blank"
                );
              } else {
                nError("预览失败");
              }
            }
          })
          .catch(errorHandler("预览失败"))
          .then(() => {
            this.downloadNoticeLoading = false;
          });
      }

      if (this.multipleText.length !== 0) {
        requestData = {
          codes: this.multipleSelection,
          templateCode: code,
          fileName: fileName,
          templateUrl: path
        };
        this.$axios
          .post(api.createPatchPropertyLedgerUrl, requestData)
          .then(res => {
            this.downloadNoticeLoading = false;
            if (res.data.retCode === 1) {
              let data = res.data.data;
              if (data) {
                window.open(
                  "http://view.officeapps.live.com/op/view.aspx?src=" + data,
                  "_blank"
                );
              } else {
                nError("预览失败");
              }
            }
          })
          .catch(errorHandler("预览失败"))
          .then(() => {
            this.downloadNoticeLoading = false;
            this.multipleSelection = [];
          });
      }
    },
    // 催款单生成并下载
    downloadContract(path, fileName, code) {
      this.downloadNoticeLoading = true;
      let requestData = {};

      this.multipleText.map(v => {
        if (this.multipleSelection.indexOf(v.code) == -1)
          this.multipleSelection.push(v.code);
      });

      if (this.currentDueOverData.code) {
        requestData = {
          code: this.currentDueOverData.code,
          templateCode: code,
          fileName: fileName,
          templateUrl: path
        };
        this.$axios
          .post(api.createPropertyLedgerUrl, requestData)
          .then(res => {
            this.downloadNoticeLoading = false;
            if (res.data.retCode === 1) {
              let data = res.data.data;
              if (data) {
                window.open(data, "_blank");
              } else {
                nError("地址无效");
              }
            }
          })
          .catch(errorHandler("生成失败"))
          .then(() => {
            this.downloadNoticeLoading = false;
          });
      }

      if (this.multipleText.length !== 0) {
        requestData = {
          codes: this.multipleSelection,
          templateCode: code,
          fileName: fileName,
          templateUrl: path
        };
        this.$axios
          .post(api.createPatchPropertyLedgerUrl, requestData)
          .then(res => {
            console.log(res);
            this.downloadNoticeLoading = false;
            if (res.data.retCode === 1) {
              let data = res.data.data;
              if (data) {
                window.open(data, "_blank");
              } else {
                nError("地址无效");
              }
            }
          })
          .catch(errorHandler("生成失败"))
          .then(() => {
            this.downloadNoticeLoading = false;
            this.multipleSelection = [];
          });
      }
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>


<style lang="less" scoped>
/deep/ ::-webkit-scrollbar {
  height: 10px;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}

.el-button--small {
  font-size: 14px;
  color: #1362ff;
}

.inputMargin {
  margin: 0 180px;
}

.contractDialogForm {
  .el-dialog__header {
    text-align: center;
  }
  .operationBox {
    span {
      cursor: pointer;
      color: #337ab7;
    }
    span:hover {
      color: #1362ff;
    }
  }
  .contractDialogLine {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    line-height: 30px;
    padding: 0 15px;
  }
  .contractDialogLine:hover {
    background-color: #eeeeee;
  }
}

/deep/.el-table .cell {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/PropertyFeeManagement/PropertyFeeManagement.vue